import React, {FC} from 'react';
import { Box, Grid } from '@mui/material';
import { RentalsCardSkeleton } from 'views/rebranded-module/common/components';

const BikeCardsSectionSkeleton:FC<any> = (props) => {
  const { isShownSideMap, bikesCount } = props;
  return (
    <Box py={4} px={2}>
      <Grid
        container
        rowSpacing={{
          xs: 2,
          md: 2,
          lg: 2,
          xl: 3,
        }}
        columnSpacing={{
          xs: 0,
          md: 2,
          lg: 2,
          xl: 3,
        }}>
      {[...Array(bikesCount)].map((_, item) => (
          <Grid
            item
            xl={isShownSideMap ? 4 : 3}
            lg={isShownSideMap ? 6 : 4}
            md={6}
            xs={12}
            key={item}>
            <RentalsCardSkeleton />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
export { BikeCardsSectionSkeleton };
